import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { ArrowRight } from "@phosphor-icons/react";
const CARDS = [
    {
        id: "hoshizora",
        name: "Hoshizora",
        subtitle: "Refined Brilliance from Japan",
        href: "/hoshizora",
        bg: "#F8F6F2",
        accent: "#6F7D69",
        logoType: "image",
        logoSrc: "https://customer-assets-wrfwihn1.emergentagent.net/job_jewelry-hub-198/artifacts/e39b392c72fa5738_56F3A412-4352-4047-80A1-25129E892630.webp",
    },
    {
        id: "heelsandtea",
        name: "Heels & Tea",
        subtitle: "Curated Fashion & Lifestyle",
        href: "/heelsandtea",
        bg: "#FBF4F2",
        accent: "#B47884",
        logoType: "image",
        logoSrc: "https://customer-assets-wrfwihn1.emergentagent.net/job_jewelry-hub-198/artifacts/58707897c98247bb_3E685BAE-22BD-415A-9830-E8653C07DDFA.webp",
    },
];

export default function PublicLanding() {
    const { user } = useAuth();
    const navigate = useNavigate();

    // If an authenticated session is active, send them to the workspace.
    useEffect(() => {
        if (user && user.id) navigate("/catalog", { replace: true });
    }, [user, navigate]);

    // Keep the landing neutral (defaults to Hoshizora sage) — each card still
    // uses its own brand accent inline via BRAND_META.
    useEffect(() => {
        document.documentElement.setAttribute("data-brand", "hoshizora");
    }, []);

    return (
        <div className="min-h-screen w-full bg-ivory grain overflow-x-hidden flex flex-col">
            <main className="flex-1 w-full max-w-6xl mx-auto px-5 md:px-10 pb-16 pt-12 md:pt-20">
                <div className="text-center md:text-left mb-10 md:mb-14">
                    <div className="eyebrow">Welcome</div>
                    <h1 className="font-serif text-4xl md:text-6xl tracking-tight mt-2 leading-tight">
                        Explore Our Collections
                    </h1>
                    <p className="text-sm text-neutral-500 mt-3 max-w-md mx-auto md:mx-0">
                        Discover two distinct worlds of style, thoughtfully curated for you.
                    </p>
                    <p className="text-xs text-neutral-400 mt-1 max-w-md mx-auto md:mx-0">
                        No account needed to explore.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8" data-testid="brand-card-grid">
                    {CARDS.map((c) => (
                        <Link
                            key={c.id}
                            to={c.href}
                            data-testid={`brand-card-${c.id}`}
                            className="group relative overflow-hidden rounded-sm border border-mist hover:border-black/30 transition-all duration-300 hover:shadow-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sage-dark"
                            style={{ background: c.bg }}
                        >
                            <div className="aspect-[4/5] md:aspect-[5/6] flex flex-col items-center justify-center p-8 md:p-12 text-center relative">
                                <div className="flex items-center justify-center w-full">
                                    {c.logoType === "image" ? (
                                        <img
                                            src={c.logoSrc}
                                            alt={c.name}
                                            draggable={false}
                                            className="h-16 md:h-20 w-auto object-contain select-none [mix-blend-mode:multiply] transition-transform duration-500 group-hover:scale-105"
                                        />
                                    ) : (
                                        <span className="font-serif text-3xl md:text-4xl tracking-tight" style={{ color: c.accent }}>
                                            {c.name}
                                        </span>
                                    )}
                                </div>
                                <div className="space-y-2 mt-8 md:mt-10">
                                    <div className="font-serif text-2xl md:text-3xl tracking-tight" style={{ color: c.accent }}>
                                        {c.name}
                                    </div>
                                    <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500">
                                        {c.subtitle}
                                    </div>
                                </div>
                                <div
                                    className="mt-6 md:mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] py-2.5 px-5 rounded-full border transition-colors"
                                    style={{ borderColor: c.accent, color: c.accent }}
                                >
                                    Explore Collection
                                    <ArrowRight size={14} weight="light" className="transition-transform group-hover:translate-x-1" />
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </main>

            <footer className="px-5 md:px-10 py-6 text-xs text-neutral-400 border-t border-mist flex items-center justify-between">
                <span>© {new Date().getFullYear()}</span>
                <Link
                    to="/login"
                    data-testid="landing-team-signin"
                    className="text-[11px] uppercase tracking-widest text-neutral-400 hover:text-neutral-700 transition-colors"
                >
                    Team sign in
                </Link>
            </footer>
        </div>
    );
}
